export default __webpack_public_path__ + "static/paul-1bd9dac2c66e472b03527e5fd048cfd8.jpg";